export default {
  props: {
    theme: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    classModifiers() {
      return {
        'market-trading-unavailable-v2': true,
        [`market-trading-unavailable-v2--${this.theme}`]: this.theme,
      };
    },
  },
};
